module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    ref: "ModalEditOrder",
    attrs: {
      "id": "ModalEditOrder",
      "size": "lg",
      "centered": ""
    },
    on: {
      "hidden": _vm.modalHasBeenHidden,
      "shown": _vm.initEditOrder
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-title"
    },
    slot: "modal-title"
  }, [(_vm.order) ? _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Изменить заказ № " + _vm._s(_vm.order.id))]) : _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Новый заказ")])]), _vm._v(" "), (_vm.loading) ? _c('loading', {
    attrs: {
      "size": 3,
      "message": "Сохраняем..."
    }
  }) : _c('form', {
    attrs: {
      "сlass": "form-horizontal"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-6 col-md-2",
    class: {
      'has-danger': _vm.$v.newOrderData.orderDate.$error
    }
  }, [_c('datepicker', {
    attrs: {
      "format": "dd/MM/yyyy",
      "lang": "ru",
      "tabindex": 1
    },
    on: {
      "input": function($event) {
        _vm.$v.newOrderData.orderDate.$touch()
      }
    },
    model: {
      value: (_vm.newOrderData.orderDate),
      callback: function($$v) {
        _vm.$set(_vm.newOrderData, "orderDate", $$v)
      },
      expression: "newOrderData.orderDate"
    }
  }), _vm._v(" "), (_vm.$v.newOrderData.orderDate.$error) ? _c('span', {
    staticClass: "small help-block text-danger"
  }, [_vm._v("Дата обязательна")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group col-6 col-md-2",
    class: {
      'has-danger': _vm.$v.newOrderData.orderTime.$error
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newOrderData.orderTime),
      expression: "newOrderData.orderTime"
    }],
    staticClass: "form-control",
    attrs: {
      "tabindex": "2"
    },
    on: {
      "input": function($event) {
        _vm.$v.newOrderData.orderTime.$touch()
      },
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newOrderData, "orderTime", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.timeOptions), function(item) {
    return _c('option', {
      domProps: {
        "value": item
      }
    }, [_vm._v(_vm._s(item))])
  })), _vm._v(" "), (_vm.$v.newOrderData.orderTime.$error) ? _c('span', {
    staticClass: "small help-block text-danger"
  }, [_vm._v("Время обязательно")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-12 col-md-3"
  }, [_c('multiselect', {
    attrs: {
      "tabindex": 3,
      "options": _vm.cities,
      "searchable": true,
      "close-on-select": true,
      "show-labels": false,
      "placeholder": "Город не выбран",
      "allow-empty": false,
      "track-by": "id",
      "label": "name"
    },
    on: {
      "input": _vm.loadTechcenters
    },
    model: {
      value: (_vm.citySelected),
      callback: function($$v) {
        _vm.citySelected = $$v
      },
      expression: "citySelected"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group col-12 col-md-5",
    class: {
      'has-danger': _vm.$v.newOrderData.techcenterId.$error
    }
  }, [_c('multiselect', {
    attrs: {
      "tabindex": 4,
      "options": _vm.techcenters,
      "searchable": true,
      "close-on-select": true,
      "show-labels": false,
      "allow-empty": true,
      "placeholder": "Техцентр не выбран",
      "track-by": "id",
      "label": "name",
      "loading": _vm.loadingTechcenters,
      "value": null
    },
    on: {
      "input": _vm.setTechcneter
    },
    model: {
      value: (_vm.techcenterSelected),
      callback: function($$v) {
        _vm.techcenterSelected = $$v
      },
      expression: "techcenterSelected"
    }
  }), _vm._v(" "), (_vm.$v.newOrderData.techcenterId.$error) ? _c('span', {
    staticClass: "small help-block text-danger"
  }, [_vm._v("Обязательно укажите техцентр")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-12",
    class: {
      'has-danger': _vm.$v.newOrderData.description.$error
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newOrderData.description),
      expression: "newOrderData.description"
    }],
    staticClass: "form-control",
    attrs: {
      "cols": "30",
      "rows": "10",
      "tabindex": 5
    },
    domProps: {
      "value": (_vm.newOrderData.description)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newOrderData, "description", $event.target.value)
      }, function($event) {
        _vm.$v.newOrderData.description.$touch()
      }]
    }
  }), _vm._v(" "), (_vm.$v.newOrderData.description.$error) ? _c('span', {
    staticClass: "small help-block text-danger"
  }, [_vm._v("Описание должно состоять как минимум из " + _vm._s(_vm.$v.newOrderData.description.$params.minLength.min) + " символов")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-12 col-md-6",
    class: {
      'has-danger': _vm.$v.newOrderData.clientPhone.$error
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("+7")]), _vm._v(" "), (_vm.newOrderData.clientPhone !== '**********') ? _c('input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('(###) ###-##-##'),
      expression: "'(###) ###-##-##'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.newOrderData.clientPhone),
      expression: "newOrderData.clientPhone"
    }],
    staticClass: "input-mask-phone form-control",
    attrs: {
      "type": "text",
      "tabindex": 6
    },
    domProps: {
      "value": (_vm.newOrderData.clientPhone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newOrderData, "clientPhone", $event.target.value)
      }
    }
  }) : _c('input', {
    staticClass: "form-control disabled",
    attrs: {
      "type": "text",
      "disabled": "",
      "value": "(***) ***-**-**"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-12 col-md-6",
    class: {
      'has-danger': _vm.$v.newOrderData.clientName.$error
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newOrderData.clientName),
      expression: "newOrderData.clientName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Имя клиента",
      "tabindex": 7
    },
    domProps: {
      "value": (_vm.newOrderData.clientName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newOrderData, "clientName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-12 col-md-6 flex-md-first",
    class: {
      'has-danger': _vm.$v.newOrderData.sum.$error
    }
  }, [_c('span', [_vm._v("Первоначальная cумма заказ-наряда")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newOrderData.sum),
      expression: "newOrderData.sum"
    }],
    staticClass: "input-mask-phone form-control text-right",
    attrs: {
      "type": "number",
      "tabindex": 8
    },
    domProps: {
      "value": (_vm.newOrderData.sum)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newOrderData, "sum", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-rub"
  })])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('div', {
    attrs: {
      "id": "buttonAddOrEditOrder"
    }
  }, [(!_vm.loading) ? _c('button', {
    staticClass: "btn btn-success",
    class: {
      'disabled': _vm.$v.newOrderData.$invalid
    },
    attrs: {
      "disabled": _vm.$v.newOrderData.$invalid,
      "type": "button",
      "tabindex": 8
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.beforeUpdateForm($event)
      }
    }
  }, [(_vm.order) ? [_vm._v("Сохранить изменение")] : [_vm._v("Добавить заказ")]], 2) : _vm._e()]), _vm._v(" "), (_vm.$v.newOrderData.$invalid) ? _c('b-tooltip', {
    attrs: {
      "target": "buttonAddOrEditOrder",
      "title": "Обязательно заполните все поля"
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /home/alarmplan/production/shared/frontend/~/vue-loader/lib/template-compiler?{"id":"data-v-23cdad5e"}!/home/alarmplan/production/shared/frontend/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modals/ModalEditOrder.vue
// module id = 1011
// module chunks = 1